export const germanMonthName = [ 'Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez' ];
export const globalMonthName = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];

export const germanWeekdayNames = [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ];
export const globalWeekdayNames = [ 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA' ];

export const DEFAULT_START_DATE = '2022-01-01';
export const DEFAULT_END_DATE = '2022-11-30';